<div class="relative inline-block text-left dropdown-container">
  <div (click)="toggleDropdown()">
    <ng-content></ng-content>
  </div>
  @if (isDropdownOpen){
  <div
    class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 z-[999]">
    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
      @for(item of optionItems(); track item.label) {
      <a class="flex flex-row items-center px-4 py-2 text-sm hover:text-secondary hover:bg-surface-muted"
        [ngClass]="item.loading || item.disabled() ? 'cursor-not-allowed opacity-50': 'cursor-pointer'" role="menuitem"
        (click)="!item.loading && getDataSelected(item.callback)">
        @if (item.loading) {
        <app-loading-spinner></app-loading-spinner>
        } @else {
        @if (item.src) {
        <img [src]="item.src" alt="Icon" class="w-4 h-4 mr-2" />
        }
        @if (item.icon === 'square-pen') {
        <app-icon-square-pen class="mr-2"></app-icon-square-pen>
        }
        }
        {{item.label}}
      </a>
      }
    </div>
  </div>
  }

</div>